// behaviors の barrel（全ミッションを runtime import する入口）を引き込まない
// よう、型だけを types から直接 import する。
import type { HudStyle } from '../behaviors/types'
import type { HudBounds } from './HudOverlay'

/**
 * 出力ログの既定 top。上端（top:0）の wide 帯（フォント 26px + 余白 +
 * 枠で高さ最大約 53px）に隠れない値。
 */
const OUTPUT_LOG_TOP = 64

/** wide 帯 1 本ぶんとして空ける高さ（帯の最大高 + 余白）。実測が無い時の予備。 */
const HUD_BAND_RESERVED_HEIGHT = 64

/** 帯とログの間の余白。 */
const HUD_BAND_MARGIN = 8

/**
 * 「画面上部の帯」とみなす top の上限（px）。これより下から始まる帯
 * （RJF09 の 80% 帯等）は上部固定のログと重ならないため避けない。
 */
const UPPER_BAND_TOP_LIMIT = 200

/**
 * 出力ログの top を、表示中のミッション GUI と重ならないよう算出する。
 * HudOverlay は OutputLog より後に描画される（=重なると GUI がログを隠す）
 * ため、画面上部に出る wide 帯のぶんだけログを下へ逃がす。
 * - 帯なし/バッジのみ: 既定の OUTPUT_LOG_TOP（カウント類は左上、ログは右上で住み分け）
 * - wide 帯: 実測 bounds（文言の折り返しによる多行化も含む）の下端より下
 * - 実測が未着の間は HudStyle からの概算で代用する
 */
export const outputLogTop = (
  style?: HudStyle,
  bounds?: HudBounds | null,
): number | string => {
  if (!style?.wide) {
    return OUTPUT_LOG_TOP
  }
  if (bounds) {
    if (bounds.top >= UPPER_BAND_TOP_LIMIT) {
      return OUTPUT_LOG_TOP
    }
    return Math.max(OUTPUT_LOG_TOP, bounds.bottom + HUD_BAND_MARGIN)
  }
  const top = style.top ?? 0
  if (typeof top === 'number') {
    return top >= UPPER_BAND_TOP_LIMIT ? OUTPUT_LOG_TOP : (
        Math.max(OUTPUT_LOG_TOP, top + HUD_BAND_RESERVED_HEIGHT)
      )
  }
  const percent = /^(\d+(?:\.\d+)?)%$/.exec(top)
  return percent && Number(percent[1]) <= 25 ?
      `max(${OUTPUT_LOG_TOP}px, calc(${top} + ${HUD_BAND_RESERVED_HEIGHT}px))`
    : OUTPUT_LOG_TOP
}
